import { ReactElement } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { Checkbox, FormFeedback, FormGroup } from '../../components';
import { baseClass, RegisterFormData } from './CreateAccount';

export interface CheckboxGroupProps {
  control: Control<RegisterFormData>;
  errors: FieldErrors<RegisterFormData>;
  trigger: (titles: string[]) => void;
}

export const CheckboxFields = ({ control, trigger, errors }: CheckboxGroupProps): ReactElement => {
  return (
    <>
      <FormGroup className={`${baseClass}__checkbox-group`}>
        <div className={`${baseClass}__checkbox-container`}>
          <Controller
            control={control}
            name="confirmTermsOfUse"
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                name="confirmTermsOfUse"
                className={`${baseClass}__checkbox`}
                aria-label="Confirm Terms of Use"
                checked={value}
                onInputChange={() => {
                  onChange(!value);
                  trigger(['confirmTermsOfUse']);
                }}
                data-testid="termsOfUseCheckbox"
              />
            )}
          />
          <span>
            I have read and accept the{' '}
            <a href="https://www.scholastic.com/terms.htm" target="_blank" rel="noreferrer">
              Terms of Use
            </a>
            .
          </span>
        </div>
        <FormFeedback>{errors.confirmTermsOfUse?.message}</FormFeedback>
      </FormGroup>
      <FormGroup className={`${baseClass}__checkbox-group`}>
        <div className={`${baseClass}__checkbox-container`}>
          <Controller
            control={control}
            name="confirmPrivacyPolicy"
            defaultValue={false}
            render={({ field: { onChange, value } }) => (
              <Checkbox
                className={`${baseClass}__checkbox`}
                aria-label="Confirm Privacy Policy"
                checked={value}
                onInputChange={() => {
                  onChange(!value);
                  trigger(['confirmPrivacyPolicy']);
                }}
                data-testid="privacyPolicyCheckbox"
              />
            )}
          />
          <span>
            I have read and accept the{' '}
            <a
              href="https://educationsolutions.scholastic.com/privacypolicy.html"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
            .
          </span>
        </div>
        <FormFeedback>{errors.confirmPrivacyPolicy?.message}</FormFeedback>
      </FormGroup>
    </>
  );
};

export default CheckboxFields;
